import React from 'react';
import clsx from 'clsx';

import styles from '../styles.module.scss';
import comparisonStyles from './Comparison.module.scss';
import {Tick2, Infinite} from '../../../assets';

export const ComparisonMobCard = ({data, active}) => {
  return (
    <div className={comparisonStyles.mobWrapper}>
      <div className={comparisonStyles.header}>
        {data.header.map((item) => (
          <div className={comparisonStyles.headerItem} key={item.id}>
            <div className={clsx(styles.label, styles[item.label])}>
              <div className={clsx(styles.labelInner, styles[item.label])}>{item.label}</div>
            </div>
            <div className={comparisonStyles.top}>
              <p className={comparisonStyles.price}>${item.price}</p>
              <p className={comparisonStyles.condition}>{item.condition}</p>
            </div>
          </div>
        ))}
      </div>
      <div className={comparisonStyles.footer}>
        {data.footer.map((item, i) => (
          <div className={comparisonStyles.footerItem} key={i}>
            <p className={comparisonStyles.title}>{item.title}</p>
            <div className={comparisonStyles.listFeatures}>
              {item.features.map((feature, i) => (
                <div className={comparisonStyles.feature} key={i}>
                  <p className={comparisonStyles.featureName} key={feature.name + i}>
                    {feature.name}
                  </p>
                  <div className={comparisonStyles.featureList}>
                    {feature.list.map((listItem, i) => (
                      <div
                        className={clsx(comparisonStyles.featureListItem, {
                          [comparisonStyles.active]: active === data.header[i].mark,
                        })}
                        key={listItem + i}>
                        <div className={comparisonStyles.infinite}>
                          {listItem === 'infinity' && <Infinite />}
                        </div>
                        <div className={comparisonStyles.tick}>
                          {listItem === 'check' && <Tick2 />}
                        </div>
                        <div className={comparisonStyles.tick}>
                          {listItem === '-' && <div></div>}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
